import React from 'react'

import BusinessSection from '@/business-section'
import Testimonial from '@/testimonial'

import './styles.css'

const SectionMeetOutTeam = ({ data, gray }) => {
  return (
    <BusinessSection gray={gray} title="Meet our team">
      <div className="mw800 center">
        <Testimonial
          avatarSrc={data.Matti.sizes}
          name="Matti Ketolainen"
          status={<span>Head of Partnerships <br/> Next Miss</span>}
          comment="“My focus is always to deliver great results for our clients. For me, the best part about working with Next Miss is to cooperate with such exceptionally talented teams from all over the world.”"
        />
        <Testimonial
          avatarSrc={data.Kaius.sizes}
          name="Kaius Meskanen"
          status={<span>Board Member <br/> Next Miss</span>}
          comment="“I believe in partnerships with great people and powerful execution of state-of-the-art Next Miss service. Delivering great results for our clients is always my first priority.”"
        />
        <Testimonial
          avatarSrc={data.Christina.sizes}
          name="Christina Joyce"
          status={<span>Head of Americas <br/> Next Miss</span>}
          comment="“I’m proud to offer the Next Miss platform for a growing number of satisfied local, state and national clients. I personally want to help transform beauty pageants into life-changing events for young women to foster self-confidence, self-expression and community-building. NextMiss allows our customers to access world-class digital tools with little to no upfront costs.”"
        />
        <Testimonial
          avatarSrc={data.Visa.sizes}
          name="Visa Pekkinen"
          status={<span>Voting Director  <br/> Next Miss</span>}
          comment="“I have helped our clients to reach +1mil votes in total. I make sure every client gets state-of-the-art casting, voting, judge rating and content in general live in real time situations, regardless of location and time zone.”"
        />
      </div>
    </BusinessSection>
  )
}

export default SectionMeetOutTeam



// WEBPACK FOOTER //
// ./src/components/section-meet-out-team/section-meet-out-team.js